import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type Language = 'ko' | 'en';

interface LanguageState {
  currentLanguage: Language;
}

const initialState: LanguageState = {
  currentLanguage: 'ko',
};

export const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage(state, action: PayloadAction<Language>) {
      state.currentLanguage = action.payload;
    },
  },
});

export const lang = languageSlice.actions;
export default languageSlice.reducer;
